import { Card, CardContent } from '../ui/card';
import { ExternalLink } from 'lucide-react';
import { GIVEAWAY_CONFIG } from './GameData';

export const HeroSection = () => (
  <section className="relative z-10 pt-8 sm:pt-16 pb-8 px-4">
    <div className="max-w-4xl mx-auto text-center">
      <div className="game-show-badge mb-8">
        <h2 className="text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-black game-show-title leading-tight">
          THIS IS A
          <br />
          <span className="text-5xl sm:text-7xl md:text-8xl lg:text-9xl neon-text-blue">
            GAME SHOW
          </span>
        </h2>
      </div>

      <a 
        href={GIVEAWAY_CONFIG.url}
        target="_blank"
        rel="noopener noreferrer"
        className="block max-w-xl mx-auto"
      >
        <Card className="giveaway-card border-4 cursor-pointer">
          <CardContent className="p-6 sm:p-8 text-center">
            <div className="text-4xl sm:text-5xl mb-4">🎁</div>
            <h3 className="text-xl sm:text-2xl md:text-3xl font-black text-white mb-4 leading-tight">
              Enter for a<br />
              chance to win<br />
              Amazon $5 Gift Cards!
            </h3>
            <div className="inline-flex items-center gap-2 text-blue-400 text-lg font-black">
              <span>CLICK TO ENTER</span>
              <ExternalLink className="w-6 h-6" />
            </div>
          </CardContent>
        </Card>
      </a>
    </div>
  </section>
);
